export default {
    title: 'កម្មវិធីភក្ដីភាព',
    title_faqs: 'សំណួរដែលសួរច្រើនសម្រាប់កម្មវិធីភក្តីភាព',
    history_reward: {
        title: 'ប្រវត្ដិការទទួលបានរង្វាន់',
        total_active: 'សកម្មសរុប',
        total_spent: 'ចំណាយសរុប',
        total_expired: 'សរុបបានផុតកំណត់',
        total_cashback: 'ប្រាក់ត្រឡប់មកវិញសរុប',
        info: 'បច្ចុប្បន្នភាព ធ្លាប់ឈ្នះរង្វាន់ {startDate} ដល់ {endDate}',
    },
    benefits: {
        entry_into_loyalty_program: {
            title: 'ការចូលទៅក្នុងកម្មវិធីភក្ដីភាព',
            content:
                'ចាប់ផ្តើមដំណើររបស់អ្នកឆ្ពោះទៅរករង្វាន់ផ្តាច់មុខនៅពេលអ្នកចូលកម្មវិធី។',
        },
        purchasing_power: {
            title: 'កម្លាំងទិញ',
            content: 'ទិញសេវាកម្មបង្ហោះជាច្រើនដែលមាននៅ 1Byte ។',
        },
        customer_support: {
            title: 'ជំនួយការអតិថិជន',
            content: 'ក្រុមជំនួយផ្តាច់មុខដែលធានានូវបទពិសោធន៍រលូន។',
        },
        cashback_rewards: 'រង្វាន់សាច់ប្រាក់ត្រឡប់មកវិញ',
        cashback_reward_content: 'ទទួលបាន {cashback} លើការចំណាយ។',
        higher_cashback: 'រង្វាន់សាច់ប្រាក់ត្រឡប់មកវិញខ្ពស់ជាង',
        highest_cashback: 'រង្វាន់សាច់ប្រាក់ត្រលប់មកវិញខ្ពស់បំផុត',
        exclusive_discounts: {
            title: 'ការបញ្ចុះតម្លៃពិសេស',
            special_content: 'ចូលប្រើការបញ្ចុះតម្លៃពិសេសលើសេវាកម្ម។',
            premium_content: ' ចូលប្រើការបញ្ចុះតម្លៃបុព្វលាភលើសេវាកម្ម។',
        },
        cashback: 'សាច់ប្រាក់ត្រលប់មកវិញ {amount}%',
    },
    level_up: {
        title: 'ឡើង​កម្រិត',
        wordpress_hosting: {
            title: 'ការបង្ហោះ WordPress',
            description:
                'WordPress Hosting ដែលមានល្បឿនលឿនជាមួយនឹងការគាំទ្រឯកទេស និងលក្ខណៈពិសេស។',
        },
        cloud_hosting: {
            title: 'ប្រព័ន្ធផ្ទុកលើពពក',
            description:
                'ការធ្វើមាត្រដ្ឋាន បង្ហោះដែលអាចទុកចិត្តបាននៅក្នុងពពកសម្រាប់ភាពបត់បែន។',
        },
        shared_hosting: {
            title: 'ចែករំលែកប្រព័ន្ធផ្ទុក',
            description:
                'ការបង្ហោះដែលងាយស្រួលនឹងថវិកាជាមួយនឹងធនធានចែករំលែកសម្រាប់គេហទំព័រតូចៗ។',
        },
        domain: {
            title: 'ដែន',
            description:
                'អាស័យដ្ឋានគេហទំព័រតែមួយគត់សម្រាប់ម៉ាកយីហោ និងអត្តសញ្ញាណអនឡាញ។',
        },
        cloud_server: {
            title: 'Cloud Server',
            description:
                'Virtual Server ដែលអាចធ្វើមាត្រដ្ឋានបាននៅក្នុងពពកសម្រាប់ដំណើរការអាជីវកម្ម។',
        },
        sms_service: {
            title: 'ប្រើប្រាស់សេវាកម្ម SMS',
            description:
                'ការផ្ញើសារជាអក្សរសម្រាប់ទីផ្សារ ការជូនដំណឹង និងការផ្សព្វផ្សាយដល់អតិថិជន។',
        },
        aws: {
            title: 'AWS',
            description:
                'ដៃគូ AWS នាំមុខគេក្នុងប្រទេសកម្ពុជាសម្រាប់ដំណោះស្រាយលើពពកដែលគួរឱ្យទុកចិត្ត។',
        },
        ssl: {
            title: 'វិញ្ញាបនបត្រ SSL',
            description: 'សុវត្ថិភាពគេហទំព័ររបស់អ្នក តាមវិធីរបស់អ្នក។',
        },
    },
    history_rank_title: 'ប្រវត្តិនៃកម្រិតឡើង',
    spent: 'បានចំណាយ',
    amount: 'ចំនួនទឹកប្រាក់',
    issue_date: 'កាលបរិច្ឆេទចេញផ្សាយ',
    exp_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    current_badge: {
        next_period: 'ចំណាត់ថ្នាក់នឹងត្រូវបានអាប់ដេតម្តងទៀតបន្ទាប់ពី {endDate}',
        see_history: 'មើលប្រវត្តិ',
        title: 'ផ្លាកសញ្ញាបច្ចុប្បន្ន',
        maintain_rank: 'អ្នកនឹងបន្តរក្សាចំណាត់ថ្នាក់នេះសម្រាប់រយៈពេលបន្ទាប់',
        maintain_rank_in_progress:
            'ចំណាយបន្ថែម {amount} ដើម្បីរក្សាចំណាត់ថ្នាក់នេះសម្រាប់រយៈពេលបន្ទាប់',
    },
};
